import { ReactElement } from 'react';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type Props = {
  id: string;
  title: string | ReactElement;
};

export const SubFormAccordion: React.FC<Props> = ({ id, title, children }) => (
  <Accordion>
    <AccordionSummary
      aria-controls={id}
      expandIcon={<ExpandMoreIcon />}
      id={id}
    >
      <Typography>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </Accordion>
);

export default SubFormAccordion;
